import moment from 'moment';
import {
	buildLineCompareAnchorFromOrderRange,
	buildLineCompareAnchorFromQuickPickMerged,
} from './statisticsComparePresets';
import { ORDER_DATE_QUICK_PICK_CONFIRMED, RELEASE_OVERVIEW_PERIOD } from './statisticsOrderDatePatch';
import {
	STATISTICS_ROLLING_PERIOD_PRESETS,
	buildRollingPeriodRange,
	matchRollingPeriodPresetId,
} from './statisticsPeriodQuickPickUtils';

export const OVERVIEW_PERIOD_UNITS = [
	{ id: 'year', label: '当年', rollingId: 'thisYear' },
	{ id: 'month', label: '当月', rollingId: 'thisMonth' },
	{ id: 'quarter', label: '当季', rollingId: 'thisQuarter' },
];

const ROLLING_ID_TO_UNIT = {
	thisYear: 'year',
	thisMonth: 'month',
	thisQuarter: 'quarter',
};

const findRollingPreset = (rollingId) => STATISTICS_ROLLING_PERIOD_PRESETS.find((item) => item.id === rollingId) ?? null;

/** 与筛选「本年/本月/本季」同一套：期初～今日 */
export const resolveOverviewPeriodUnitRange = (unitId) => {
	const unit = OVERVIEW_PERIOD_UNITS.find((item) => item.id === unitId);
	if (!unit) return null;
	const preset = findRollingPreset(unit.rollingId);
	if (!preset) return null;
	const range = buildRollingPeriodRange(preset);
	return {
		startDate: range.startDate,
		endDate: range.endDate,
		label: range.label,
	};
};

/** 由下单区间回显标题区数据档：year | month | quarter | ''（本周等自定义） */
export const resolveOverviewPeriodUnit = (startDate, endDate, trendAnchor = null) => {
	const rollingId = matchRollingPeriodPresetId(startDate, endDate);
	if (rollingId && ROLLING_ID_TO_UNIT[rollingId]) {
		return ROLLING_ID_TO_UNIT[rollingId];
	}

	if (trendAnchor?.periodAxis === 'month' && Array.isArray(trendAnchor.months) && trendAnchor.months.length === 1) {
		return 'month';
	}
	if (trendAnchor?.periodAxis === 'quarter' && Array.isArray(trendAnchor.quarters) && trendAnchor.quarters.length === 1) {
		return 'quarter';
	}
	return '';
};

const buildUnitTrendAnchor = (unitId, range) => {
	if (!range?.startDate || !range?.endDate) return null;
	const now = moment();
	if (unitId === 'month') {
		return buildLineCompareAnchorFromQuickPickMerged({
			startDate: range.startDate,
			endDate: range.endDate,
			label: '本月',
			periodAxis: 'month',
			months: [now.month()],
		});
	}
	if (unitId === 'quarter') {
		return buildLineCompareAnchorFromQuickPickMerged({
			startDate: range.startDate,
			endDate: range.endDate,
			label: '本季',
			periodAxis: 'quarter',
			quarters: [Math.floor(now.month() / 3)],
		});
	}
	return buildLineCompareAnchorFromOrderRange(range.startDate, range.endDate);
};

/** 标题档 → 查询用日期 patch；不写入 datePeriods，避免带进自定义日期列 */
export const buildOverviewPeriodUnitFilterPatch = (unitId) => {
	const range = resolveOverviewPeriodUnitRange(unitId);
	if (!range) return null;
	const nextAnchor = buildUnitTrendAnchor(unitId, range);
	return {
		startDate: range.startDate,
		endDate: range.endDate,
		datePeriods: null,
		[ORDER_DATE_QUICK_PICK_CONFIRMED]: true,
		...(nextAnchor ? { trendAnchor: nextAnchor } : { trendAnchor: null }),
	};
};

/** 摘要/标签清空下单日期：查询回到标题当年，并交还标题档（不再显示「自定义」） */
export const buildReleaseOverviewPeriodToYearPatch = () => {
	const yearPatch = buildOverviewPeriodUnitFilterPatch('year');
	if (!yearPatch) return null;
	return { ...yearPatch, [RELEASE_OVERVIEW_PERIOD]: true };
};
